import ProgressBar from "Components/shared/progressbar";
import Text from "Components/shared/text";
import React, { useEffect, useState } from "react";
import { Storage } from "utils/clientStorage";
import styles from "./container.module.css";
import { ToDos } from "./ToDos";

export const TodoList = ({ handleClick }) => {
  const [profile, setProfile] = useState(null);
  const [bvn, setBvn] = useState(null);
  const [pin, setPin] = useState(null);

  useEffect(() => {
    const todo = Storage.getItem("TODO");
    setProfile(todo.profile);
    setBvn(todo.bvn);
    setPin(todo.pin);
    // console.log("TO DO ", todo);
  }, []);

  const calc = () => {
    let calcBVN = bvn ? 33 : 0;
    let calcPIN = pin ? 33 : 0;
    let calcPROFILE = profile ? 34 : 100;
    let add = calcBVN + calcPIN + calcPROFILE;
    Storage.setItem("TODO_SUM", add);
    return add;
  };
  return (
    <Text tag="div" className={styles.todoContainer}>
      <Text tag="div" className={styles.todo}>
        <Text tag="div" onClick={handleClick}>
          <Text style={{ fontWeight: "600" }}>To Do list</Text>
        </Text>
        <Text tag="div">
          <ProgressBar
            value={calc()}
            style={{ padding: 0, background: "var( --social-background)" }}
          />
        </Text>
      </Text>
      <ToDos profile={profile} bvn={bvn} pin={pin} />
    </Text>
  );
};
